import axios, {
    AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig, Method,
} from "axios";
import qs from "qs";

interface RequestConfig extends AxiosRequestConfig {
    url?: string;
    pathVars?: { [key: string]: string };
    Method?: string | undefined;
    // pathVars?: { [key: string]: string };
    // withToken?: boolean;
    // useCache?: boolean;
}

interface IRequestProps {
    config: RequestConfig;
    successCallback?: (res: any) => void;
    errorCallback?: (error: any) => void;
}

// eslint-disable-next-line consistent-return
const resHandler = (response: AxiosResponse) => {
    if (response.status === 200) {
        return response.data;
    }
};

const resErrorHandler = (error: any) => {
    if (error.response && error.response.status === 401) {
        window.location.href = "/login";
    }
    return Promise.reject(error);
};

function replaceVars(config: RequestConfig) {
    const { pathVars } = config;
    let { url } = config;
    if (pathVars && url) {
        Object.keys(pathVars).forEach((key) => {
            // 数组join
            const value = pathVars?.[key];
            url = url!.replace(new RegExp(`{${key}}`, "g"), value);
        });
        config.url = url;
    }
    return config as unknown as InternalAxiosRequestConfig;
}

export const apiRequest = () => {
    const service = axios.create({
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
    });
    service.interceptors.request.use(replaceVars);
    service.interceptors.response.use(resHandler, resErrorHandler);
    return service;
};

const api: AxiosInstance = apiRequest();

export const apiWrapper = async ({
    config,
    successCallback,
    errorCallback,
}: IRequestProps): Promise<any> => new Promise((resolve, reject) => {
    const method = config.method || config.Method as Method;
    api({ ...config, method })
        .then((res) => {
            successCallback?.(res);
            resolve(res);
        })
        .catch((error) => {
            errorCallback?.(error);
            reject(error);
        });
});
